import React from 'react';

import { makeBtStyles } from '../Theme';
import { Branding, useBrandingData } from '../dataProviders';
import ThemeProvider from '../Theme';
import PoweredBy from '../components/PoweredBy';
import { usePromoImage } from '../components/PromoImage';

import { useIsLineItemsCardShown } from './LineItemsCard';

import AppBar from './AppBar';

import { CONTENT_WIDTH } from '../components/defaultStyleVars';

import TrackingPage, { MAIN_COL_WIDTH, SECONDARY_COL_WIDTH, COL_SPACING } from './TrackingPage';
import ReturnsPage from './ReturnsPage';
  

const useLayoutStyles = makeBtStyles( theme => ({
  contentWrapper: ({ lineItemsCardShown, hasPromoImage }:{ lineItemsCardShown: boolean, hasPromoImage: boolean }) => ({
    margin: '30px auto',
    width: (lineItemsCardShown || hasPromoImage) ? `${CONTENT_WIDTH}px` : (MAIN_COL_WIDTH + SECONDARY_COL_WIDTH + COL_SPACING + 'px'),
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '30px 0',
      maxWidth: 'none'
    }
  }),
}));

function Layout01({ children }:{
  branding: Branding,
  children: React.ReactNode
}) {
  const branding = useBrandingData();
  const { colors } = branding;
  const lineItemsCardShown = useIsLineItemsCardShown();
  const promoImage = usePromoImage();
  const classes = useLayoutStyles({ lineItemsCardShown, hasPromoImage: !!promoImage });

  const themeOverrides = {
    page: { background: colors && colors.secondary },
    link: { color: colors && colors.tertiary },
    characteristicColor: { color: colors && colors.primary }
  };

  return (
    <ThemeProvider configOverrides={themeOverrides}>
      <div data-testid="layout01">
        <AppBar />
        <div className={classes.contentWrapper}>
          {children}
        </div>
      </div>
      <PoweredBy />
    </ThemeProvider>
  );
}

export default {
  Layout: Layout01,
  TrackingPage,
  ReturnsPage
};
